"use strict";
module.exports = {
    HOME: 'https://providers.ahm.com.au',
};
